<script setup lang="ts">
import Account from "@/components/Account.vue";
</script>

<template>
  <Account />
</template>

<style scoped lang="scss"></style>
